// extracted by mini-css-extract-plugin
module.exports = {"image-holder":"ShowImage_image-holder__1NFA1","image":"ShowImage_image__3-l4F"};